import {
  API_ERROR,
  GET_IMPORT_MODELS_LIST,
  GET_IMPORT_MODELS_LIST_SUCCESS,
  GET_EXPORT_MODELS_LIST,
  GET_EXPORT_MODELS_LIST_SUCCESS,
  EXPORT_STATUS,
  EXPORT_STATUS_SUCCESS,
  EXPORT_DOWNLOAD_FILE,
  EXPORT_DOWNLOAD_FILE_SUCCESS,
  DOWNLOAD_EXPORT_DATA,
  DOWNLOAD_EXPORT_DATA_SUCCESS,
  IMPORT_UPLOAD_STATUS,
  IMPORT_UPLOAD_STATUS_SUCCESS,
  UPLOAD_IMPORT_DATA,
  UPLOAD_IMPORT_DATA_SUCCESS,
  UPLOAD_TABLE_PREVIEW_DATA,
  UPLOAD_TABLE_PREVIEW_DATA_SUCCESS,
  INPUT_CHANGE_VALUE,
  NEXT_STEP,
  PREV_STEP,
  FINISH_STEP,
  CHANGE_TYPE,
  CLEAR_DATA,
} from "./actionTypes";

export const apiError = (error) => ({
  type: API_ERROR,
  payload: error,
});

export const getImportModelsList = () => ({
  type: GET_IMPORT_MODELS_LIST,
});

export const getImportModelsListSuccess = (response) => ({
  type: GET_IMPORT_MODELS_LIST_SUCCESS,
  payload: response,
});

export const getExportModelsList = (data) => ({
  type: GET_EXPORT_MODELS_LIST,
  payload: data,
});

export const getExportModelsListSuccess = (response) => ({
  type: GET_EXPORT_MODELS_LIST_SUCCESS,
  payload: response,
});

export const exportStatus = (data) => ({
  type: EXPORT_STATUS,
  payload: data,
});

export const exportStatusSuccess =
 (response) => ({
  type: EXPORT_STATUS_SUCCESS,
  payload: response,
});

export const exportDownloadFile = (data) => ({
  type: EXPORT_DOWNLOAD_FILE,
  payload: data,
});

export const exportDownloadFileSuccess = (response) => ({
  type: EXPORT_DOWNLOAD_FILE_SUCCESS,
  payload: response,
});

export const downloadExportData = (data) => ({
  type: DOWNLOAD_EXPORT_DATA,
  payload: data,
});

export const downloadExportDataSuccess = (response) => ({
  type: DOWNLOAD_EXPORT_DATA_SUCCESS,
  payload: response,
});

export const importUploadStatus = (data) => ({
  type: IMPORT_UPLOAD_STATUS,
  payload: data,
});

export const importUploadStatusSuccess = (response) => ({
  type: IMPORT_UPLOAD_STATUS_SUCCESS,
  payload: response,
});

export const uploadImportData = (data) => ({
  type: UPLOAD_IMPORT_DATA,
  payload: data,
});

export const uploadImportDataSuccess = (response) => ({
  type: UPLOAD_IMPORT_DATA_SUCCESS,
  payload: response,
});

export const uploadTablePreviewData = (data) => ({
  type: UPLOAD_TABLE_PREVIEW_DATA,
  payload: data,
});

export const uploadTablePreviewDataSuccess = (response) => ({
  type: UPLOAD_TABLE_PREVIEW_DATA_SUCCESS,
  payload: response,
});

export const inputChangeValue = (data) => ({
  type: INPUT_CHANGE_VALUE,
  payload: data,
});

export const nextStep = () => ({
  type: NEXT_STEP,
});

export const prevStep = () => ({
  type: PREV_STEP,
});

export const finishStep = () => ({
  type: FINISH_STEP,
});

export const changeType = (importType) => ({
  type: CHANGE_TYPE,
  payload: importType,
});

export const clearData = () => ({
  type: CLEAR_DATA,
});
